export const welcomeView = {
    "start": "Start",
    "test_info": "Test's summary",
    "practice_info": "Practice's summary",
    "exam_info": "Exam's summary",
    "lesson_info": "Lesson's summary",
    "logged_out": "You exited in the previous attempt.",
    "continue_wc": "Continue",
};
